export default "__VITE_ASSET__C$CcWzxL__"